import type { GetBoardsDTO } from '@bb/domain/dist/types/dto/RetsController/getBoards';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

const getAllBoards = async () => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: '/rets/boards_all',
  };

  const { data } = await axios.request<GetBoardsDTO>(config);

  return data;
};

export default getAllBoards;
